module.exports = __webpack_public_path__ + "3bcc79c2753770f1337698e039df02b3.pdf";